import {alertActions as alerts, asyncPost, asyncLoad, asyncDelete} from '.';

import {formValidation} from '../helpers';

export const loadCustomStatus = () => dispatch =>
  asyncLoad({
    dispatch,
    title: 'custom status',
    url: '/customfilters/customstatus',
    params: {useMAPI: true},
  });

export const loadCustomView = customViewId => dispatch =>
  asyncLoad({
    dispatch,
    title: 'Custom View',
    url: `/custom-views/${customViewId}`,
  });

export const loadCustomViews = ({
  viewTypeId,
  viewType,
  showMyViewOnly = false,
  name = '',
  useMAPI = false,
}) => dispatch =>
  asyncLoad({
    dispatch,
    title: 'custom views',
    url: useMAPI
      ? `/customfilters?viewType=${viewType}&showMyViewOnly=${showMyViewOnly.toString()}`
      : `/custom-views?pageSize=500&customViewType=${viewTypeId}&showMyViewsOnly=${showMyViewOnly.toString()}&name=${name}`,
    params: {useMAPI},
  });

export const loadPriorities = (selected = false) => dispatch =>
  asyncLoad({
    dispatch,
    title: 'priorities',
    url: `/customfilters/priority?selected=${selected}`,
    params: {useMAPI: true},
  });

export const loadTeams = (isTeam = true) => dispatch =>
  asyncLoad({
    dispatch,
    title: 'teams',
    url: `/customfilters/team?isTeam=${isTeam}`,
    params: {useMAPI: true},
  });

export const loadTypes = (setupCustomForm = false) => dispatch =>
  asyncLoad({
    dispatch,
    title: 'types',
    url: `/customfilters/type?setupCustomForm=${setupCustomForm}`,
    params: {useMAPI: true},
  });

export const loadJobTypes = () => dispatch => {
  const jobTypeOptions = [
    {value: '0', text: 'One-time job', label: 'One-time job'},
    {value: '1', text: 'Recurring job', label: 'Recurring job'},
  ];
  return Promise.resolve(jobTypeOptions);
};

export const deleteCustomView = customViewId => dispatch =>
  asyncDelete({
    dispatch,
    title: 'custom view',
    url: `/customfilters?id=${customViewId}`,
    params: {useMAPI: true},
  });

export const addCustomView = (viewType, customView) => dispatch => {
  if (customView.items.length === 0) {
    dispatch(alerts.error('You must have at least on filter.'));
    return Promise.reject();
  }

  const formObject = formValidation.setupFormBody(customView.formFields, false);

  if (formObject.hasError) {
    dispatch(alerts.error(formObject.errorMessage));
    return Promise.reject();
  }

  return asyncPost({
    url: `/customfilters?viewType=${viewType}`,
    body: {...formObject.body, items: customView.items},
    method: 'POST',
    params: {useMAPI: true},
  });
};



// WEBPACK FOOTER //
// ./src/actions/customViewActions.js